"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compare = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/compare");
const _generatePreview = require("../../modules/files/generatePreview/reducers");
const generatePreview = _generatePreview.default('compare');
exports.initialState = {
    beforeRevision: Object.assign({}, generatePreview.initialState),
    afterRevision: Object.assign({}, generatePreview.initialState)
};
const beforeRevisionLens = monocle.Lens.fromProp('beforeRevision');
const afterRevisionLens = monocle.Lens.fromProp('afterRevision');
const statusLens = monocle.Lens.fromProp('status');
const revisionLens = new monocle.Optional((data) => data.status === 'FETCHED' ? fp.option.some(data.revision) : fp.option.none, (revision) => (data) => (Object.assign(Object.assign({}, data), { revision: revision })));
const methods = {};
methods[ActionTypes.FETCH_BEFORE_REVISION_REQUEST] = (state, action) => beforeRevisionLens.compose(statusLens).set('FETCHING')(state);
methods[ActionTypes.FETCH_BEFORE_REVISION_FAILURE] = (state, action) => beforeRevisionLens.compose(statusLens).set('FAILED')(state);
methods[ActionTypes.FETCH_BEFORE_REVISION_SUCCESS] = (state, action) => fp.function.compose(beforeRevisionLens.composeOptional(revisionLens).set(action.payload.node), beforeRevisionLens.compose(statusLens).set('FETCHED'))(state);
methods[ActionTypes.FETCH_AFTER_REVISION_REQUEST] = (state, action) => afterRevisionLens.compose(statusLens).set('FETCHING')(state);
methods[ActionTypes.FETCH_AFTER_REVISION_FAILURE] = (state, action) => afterRevisionLens.compose(statusLens).set('FAILED')(state);
methods[ActionTypes.FETCH_AFTER_REVISION_SUCCESS] = (state, action) => fp.function.compose(afterRevisionLens.composeOptional(revisionLens).set(action.payload.node), afterRevisionLens.compose(statusLens).set('FETCHED'))(state);
methods[generatePreview.ActionTypes.GENERATE_PREVIEW_REQUEST] = (state, action) => {
    if (state.afterRevision.status === 'FETCHED') {
        if (state.afterRevision.revision.uuid === action.payload) {
            return afterRevisionLens.modify((s) => generatePreview.methods[generatePreview.ActionTypes.GENERATE_PREVIEW_REQUEST](s, action))(state);
        }
    }
    if (state.beforeRevision.status === 'FETCHED') {
        if (state.beforeRevision.revision.uuid === action.payload) {
            return beforeRevisionLens.modify((s) => generatePreview.methods[generatePreview.ActionTypes.GENERATE_PREVIEW_REQUEST](s, action))(state);
        }
    }
    return state;
};
methods[generatePreview.ActionTypes.GENERATE_PREVIEW_SUCCESS] = (state, action) => {
    if (state.afterRevision.status === 'FETCHED') {
        if (state.afterRevision.revision.uuid === action.data.revisionUuid) {
            return afterRevisionLens.modify((s) => generatePreview.methods[generatePreview.ActionTypes.GENERATE_PREVIEW_SUCCESS](s, action))(state);
        }
    }
    if (state.beforeRevision.status === 'FETCHED') {
        if (state.beforeRevision.revision.uuid === action.data.revisionUuid) {
            return beforeRevisionLens.modify((s) => generatePreview.methods[generatePreview.ActionTypes.GENERATE_PREVIEW_SUCCESS](s, action))(state);
        }
    }
    return state;
};
methods[generatePreview.ActionTypes.GENERATE_PREVIEW_FAILURE] = (state, action) => {
    if (state.afterRevision.status === 'FETCHED') {
        if (state.afterRevision.revision.uuid === action.revisionUuid) {
            return afterRevisionLens.modify((s) => generatePreview.methods[generatePreview.ActionTypes.GENERATE_PREVIEW_FAILURE](s, action))(state);
        }
    }
    if (state.beforeRevision.status === 'FETCHED') {
        if (state.beforeRevision.revision.uuid === action.revisionUuid) {
            return beforeRevisionLens.modify((s) => generatePreview.methods[generatePreview.ActionTypes.GENERATE_PREVIEW_FAILURE](s, action))(state);
        }
    }
    return state;
};
const compare = (state = exports.initialState, action) => (methods[action.type] ? methods[action.type](state, action) : state);
exports.compare = compare;
//# sourceMappingURL=index.js.map